import { AnalyticsRequest, GroupBy, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { DefaultWidgetPosition } from './PanelTemplatesTheme/constants';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';
import ListeningDimensions from '../../services/AnalyticsService/ListeningDimensions';
import { TEXT_SHADOW_DEFAULT } from 'models/Widget/Widget';

export const WidgetWordCloud: Widget = {
    type: 'wordCloud',
    id: 'word-cloud',
    name: 'Word Cloud',
    useGlobalTimePeriod: true,
    analyticsRequests: [
        // Note: All global variables like reportingEngine, report, filters, and projections
        // are injected via AnalyticsRequest.getRequests()
        new AnalyticsRequest({
            limit: 25,
            groupBys: [
                new GroupBy({
                    LISTENING: { source: ListeningDimensions.wordCloudMessage },
                    INBOUND_MESSAGE: { dimensionName: 'HASHTAGS' },
                    PLATFORM: null /* This engine type not supported for this template */,
                    BENCHMARKING: { dimensionName: 'HASHTAGS' },
                    PAID: { dimensionName: 'imageTag' },
                    ADVOCACY: { dimensionName: 'COMMUNITY_USER_ID' },
                    RDB_FIREHOSE: { dimensionName: 'RDB_QUERY_IDS' },
                    STORY_MESSAGE: { dimensionName: 'WORD_CLOUD_MESSAGE' },
                    TWITTER: { dimensionName: 'TRENDING_TOPIC' },
                }),
            ],
            sorts: [
                new Sort({ order: 'DESC', projections: 0 }),
                new Sort({ order: 'ASC', groupBys: 0 }),
            ],
            timePeriods: [{ key: 'last_7_days' }],
            additional: {
                TARGET_LANG_CODE: 'en',
            },
        }) as any,
    ],
    position: DefaultWidgetPosition,
    label: {
        overlap: false,
        titleText: 'Word Cloud',
        size: WIDGET_LABEL_SIZE.primary,
        textShadow: TEXT_SHADOW_DEFAULT,
        enabled: false,
    },
    options: {
        player: {
            playing: true,
            duration: 15,
        },
        spacing: 1,
        showSentiment: false,
        smartSize: {
            enabled: true,
            mode: 'responsive',
            size: 'm',
        },
        portrait: {
            widgetOrientation: 'portrait',
        },
    },
};
